import { classNames } from "utils/ClassNames"

export interface SpinnerProps {
  className?: string
}

/** An animated loading spinner that inherits the current text color. */
export const Spinner = ({ className }: SpinnerProps) => {
  // Fall back to a sensible size when the caller hasn't set width/height,
  // otherwise the SVG expands to fill its container.
  const hasSize = className ? /\b[hw]-/.test(className) : false
  return (
    <svg
      className={classNames("animate-spin", !hasSize && "h-5 w-5", className)}
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  )
}
